<div class="ui-g-12 no-padding">
	<div class="ui-g-12 no-horizontal-padding wizard-content-title">
	</div>
	<ng-template
		[ngIf]="context.source.wizardStepLoading"
		[ngIfElse]="Content">
		<div class="ui-g-12 no-horizontal-padding text-center">
			<i class="loading-spinner theme-color fa fa-fw fa-spin fa-spinner">
			</i>
		</div>
	</ng-template>
	<ng-template #Content>
		<div class="ui-g-12 content-section">
			<div class="ui-g-6">
				<div class="ellipsis-text text-right">
					<strong>Policy ID: </strong>
				</div>
				<div class="ellipsis-text text-right">
					<strong>Transaction ID: </strong>
				</div>
				<div class="ellipsis-text text-right">
					<strong>Note: </strong>
				</div>
				<div class="ellipsis-text text-right">
					<strong>Amount: </strong>
				</div>
			</div>
			<div class="ui-g-6">
				<div class="ellipsis-text">
					{{currentData.policyNumber}}
				</div>
				<div class="ellipsis-text">
					{{currentData.transactionNumber}}
				</div>
				<div class="ellipsis-text">
					{{currentData.note}}
				</div>
				<div class="ellipsis-text">
					{{currentData.amount | currency}}
				</div>
			</div>
		</div>
	</ng-template>
</div>